import React from "react";
import { DndContext, DragEndEvent, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { observer } from "mobx-react";
import FolderTree from "react-folder-tree";
import { observable } from "mobx";
import { Title, values_nfse } from "./RelatorioData";
import { Button } from "@blueprintjs/core";
import { RelatorioStore } from "../../../stores/relatorio/RelatorioStore";
import { AppStore } from "../../../stores/AppStore";

interface Item {
  id: string;
  header: string;
  order: number;
  xml?: string;
  campo?: string;
  tag?: string;
};

interface State {
  sortedList: any
};

const EditIcon = (...args) => null;
const DeleteIcon = (...args) => null;
const CancelIcon = (...args) => null;
const FolderIcon = (...args) => null;
const FileIcon = (...args) => null;
const OKIcon = (...args) => null
const FolderOpenIcon = (...args) => null

function SortableCard({ item }: { item: Item }) {

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: "grab",
    touchAction: "none",
  };

  return (

    <div ref={setNodeRef} style={style} className="card-relatorio" {...attributes} {...listeners}>
      <div className="cardTitle">{item.order} - {item.header}</div>
      <div className="cardBody">{item.tag}</div>
    </div>

  );

}

@observer
export class RelatorioNfseForm extends React.Component<{}, State> {

  obs = observable({
    treeValues: [] as any,
    treeData: values_nfse(),
    columns: [] as any
  })

  constructor(props: {}) {
    super(props);

    if (RelatorioStore.obs.selectedEmpresa.cnpj == "") {
      AppStore.setLocation("/relatorios");
    }

    if (RelatorioStore.obs.select_relatorio.treeData.length != 0) {
      this.obs.treeData = RelatorioStore.obs.select_relatorio.treeData
    }

    if (RelatorioStore.obs.select_relatorio.columns.length != 0) {
      this.obs.columns = RelatorioStore.obs.select_relatorio.columns
    }

    this.handleDragEnd = this.handleDragEnd.bind(this);

    this.state = {
      sortedList: this.sortedList(this.obs.columns),
    };


    AppStore.setTitle("Relatório");

  }

  sortedList(list) {
    return list.slice().sort((first, second) => first.order - second.order);
  }

  private normalizeOrder(list: Item[]): Item[] {
    return list.map((item, idx) => ({
      ...item,
      order: idx + 1,
    }));
  }

  handleDragEnd(event: DragEndEvent) {

    const { active, over } = event;

    if (!over || active.id === over.id) return;

    this.setState((prev) => {

      const oldIndex = prev.sortedList.findIndex((i) => i.id === active.id);
      const newIndex = prev.sortedList.findIndex((i) => i.id === over.id);

      const moved: Item[] = arrayMove(prev.sortedList, oldIndex, newIndex);

      const withOrder = this.normalizeOrder(moved);

      return { sortedList: withOrder };

    });

  }

  handleSave() {
    let params = {
      columns: this.state.sortedList,
      treeData: this.obs.treeValues
    }

    let columns = this.state.sortedList.map(x => x)

    RelatorioStore.obs.columns = columns
    RelatorioStore.obs.relatorio = params

    AppStore.setLocation("/relatorio/filtro");

  }

  handleCancel() {

    window.location.href = "/relatorios"

  }

  render() {
    const { sortedList } = this.state;

    const ids = sortedList.map((i) => i.id);

    const onTreeStateChange = (state) => {
      let itens: any = []
      let valores = []

      if (state.checked == 0) {

        this.setState({ sortedList: [] }, () => { return });

      }

      try {

        itens = sortedList

        valores = [...sortedList].map(x => x.id)

      } catch (ex) { }

      state.children.map(x => {

        x.children.map(value => {

          if (value.checked == 1 && valores.indexOf(value.id) == -1) {

            itens.push({
              id: value.id,
              header: value.name,
              xml: value.xml,
              campo: value.campo,
              order: value.order,
              tag: value.tag
            })

          }

          if (value.checked === 0 && valores.indexOf(value.id) !== -1) {

            itens = itens.slice().filter((item) => item.id !== value.id);

          }

        })

      })

      this.setState({ sortedList: itens }, () => {

        this.obs.treeValues = state

      });

    };

    const onNameClick = () => { }

    return (<>

      <div style={{ display: "flex", width: "100%" }}>

        <div style={{ width: 500, maxHeight: 600, overflow: "auto" }}>
          <FolderTree
            data={this.obs.treeData}
            onChange={onTreeStateChange}
            iconComponents={{
              EditIcon, DeleteIcon, CancelIcon, FolderIcon, FileIcon, OKIcon, FolderOpenIcon
            }}
            onNameClick={onNameClick}
            initCheckedStatus='custom'
            initOpenStatus='custom'
          />
        </div>

        <div className="page-relatorio" style={{ maxHeight: 600, overflow: "auto" }}>
          <Title>{"Colunas"}</Title>
          <br />
          <br />
          <DndContext collisionDetection={closestCenter} onDragEnd={this.handleDragEnd}>
            <SortableContext items={ids} strategy={rectSortingStrategy}>
              <div className="grid-relatorio">
                {this.state.sortedList.map((item) => (
                  <SortableCard key={item.id} item={item} />
                ))}
              </div>
            </SortableContext>
          </DndContext>
        </div>

      </div>

      <div style={{ marginTop: "50px" }}>
        <Button
          intent="primary"
          onClick={() => this.handleSave()}
          style={{ marginRight: "10px" }}
        >
          Continuar
        </Button>
        <Button
          onClick={() => this.handleCancel()}
        >
          Cancelar
        </Button>
      </div>

    </>);
  }
}